import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;
const api = axios.create({
  baseURL: `${API_URL}/api`,
  withCredentials: true,
});

// Add admin token from localStorage as fallback for cookie issues
api.interceptors.request.use((config) => {
  const adminToken = localStorage.getItem('motoveloz-admin-token');
  if (adminToken && !config.headers['Authorization']) {
    config.headers['Authorization'] = `Bearer ${adminToken}`;
  }
  return config;
});

// Products
export const getProducts = (params) => api.get('/products', { params });
export const getProduct = (id) => api.get(`/products/${id}`);
export const getCategories = () => api.get('/categories');
export const getBrands = () => api.get('/brands');

// Auth
export const processSession = (session_id) => api.post('/auth/session', { session_id });
export const getMe = () => api.get('/auth/me');
export const logout = () => api.post('/auth/logout');
export const registerUser = (data) => api.post('/auth/register', data);
export const loginEmail = (data) => api.post('/auth/login-email', data);
export const getGoogleOAuthConfig = () => api.get('/auth/google/config');

// Favorites
export const getFavorites = () => api.get('/favorites');
export const getFavoriteIds = () => api.get('/favorites/ids');
export const addFavorite = (id) => api.post(`/favorites/${id}`);
export const removeFavorite = (id) => api.delete(`/favorites/${id}`);

// Coupons
export const validateCoupon = (code, subtotal) => api.post('/coupons/validate', { code, subtotal });
export const applyCouponUsage = (code, subtotal) => api.post('/coupons/use', { code, subtotal });

// Admin
export const adminLogin = (email, password) => api.post('/admin/login', { email, password });
export const adminMe = () => api.get('/admin/me');
export const adminLogout = () => api.post('/admin/logout');
export const adminGetStats = () => api.get('/admin/stats');
export const adminGetProducts = (params) => api.get('/products', { params });
export const adminCreateProduct = (data) => api.post('/admin/products', data);
export const adminUpdateProduct = (id, data) => api.put(`/admin/products/${id}`, data);
export const adminDeleteProduct = (id) => api.delete(`/admin/products/${id}`);
export const adminGetCoupons = () => api.get('/admin/coupons');
export const adminCreateCoupon = (data) => api.post('/admin/coupons', data);
export const adminUpdateCoupon = (id, data) => api.put(`/admin/coupons/${id}`, data);
export const adminDeleteCoupon = (id) => api.delete(`/admin/coupons/${id}`);
export const adminGetCouponUsage = () => api.get('/admin/coupons/usage');
export const adminGetCustomers = () => api.get('/admin/customers');
export const adminDeleteCustomer = (userId) => api.delete(`/admin/customers/${userId}`);
export const adminGetLowStock = () => api.get('/admin/products/low-stock');
export const adminBulkUpdate = (data) => api.put('/admin/products/bulk', data);
export const adminGetNoImage = () => api.get('/admin/products/no-image');

// Orders
export const createOrder = (data) => api.post('/orders', data);
export const getMyOrders = () => api.get('/orders');
export const adminGetOrders = () => api.get('/admin/orders');
export const adminUpdateOrderStatus = (id, status) => api.put(`/admin/orders/${id}/status`, { status });

// Push Notifications
export const subscribePush = (subscription) => api.post('/notifications/subscribe', { subscription });
export const adminGetPushCount = () => api.get('/admin/notifications/count');
export const adminSendNotification = (data) => api.post('/admin/notifications/send', data);

// Reviews
export const getProductReviews = (productId, page = 1) => api.get(`/reviews/${productId}`, { params: { page } });
export const createReview = (productId, data) => api.post(`/reviews/${productId}`, data);
export const deleteReview = (reviewId) => api.delete(`/reviews/${reviewId}`);
export const adminGetReviews = () => api.get('/admin/reviews');
export const adminDeleteReview = (reviewId) => api.delete(`/admin/reviews/${reviewId}`);

export const seedDatabase = () => api.post('/seed');

export default api;
